import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'opac-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
})
export class RatingComponent implements OnChanges, OnInit {
  private static readonly STARS_COUNT = 5;

  readonly starsIterable = Array(RatingComponent.STARS_COUNT).fill(0).map((_, i) => i + 1);

  activeStars = 0;

  /**
   * Determines if user can rate the title
   */
  @Input() disabled: boolean = false;
  /**
   * Sets the rating for the title
   */
  @Input() rating: number = 0;
  /**
   * Determines if the rating was done by user, or it is the mean of all users
   */
  @Input() ratedByUser: boolean = false;
  /**
   * Outputs rate change when user selects rating
   */
  @Output() change = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {
    if (this.ratedByUser) {
      this.activeStars = this.rating;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rating) {
      this.activeStars = this.ratedByUser ? changes.rating.currentValue : 0;
    }
  }

  handleMouseOver(count: number) {
    if (!this.disabled) {
      this.activeStars = count;
    }
  }

  handleMouseOut() {
    this.activeStars = this.ratedByUser ? this.rating : 0;
  }

  handleClick(count: number) {
    if (!this.disabled) {
      this.change.emit(count);
    }
  }
}
